import {
    Popover,
} from 'antd';
import React, {FC} from 'react';

import {DynamicIcon} from 'components/dynamic-icon';
import {ModalOpenerComponent} from 'components/modal-opener-component';
import {setFieldsValueUntouched} from 'shared/utils';
import {IReportDdReferenceRule} from 'store/slices/report-configuration-slice/dd-references-configuration';

import './dd-grouping-settings-modal-opener.less';
import {DDGroupingSettingsModalForm} from './components';
import {useDDGroupingSettingsModalOpener} from './use-dd-grouping-settings-modal-opener';

interface IGroupingSettingsModalOpenerProps {
    drilldownReferenceRules: IReportDdReferenceRule[];
    index: number;
}

export const DDGroupingSettingsModalOpener: FC<IGroupingSettingsModalOpenerProps> = ({
    drilldownReferenceRules,
    index,
}: IGroupingSettingsModalOpenerProps) => {
    const {
        usingGroup,
        isSavingData,
        isAttributesLoaded,
        form,
        modalOpenerRef,
        initialValues,
        attributesEntries,
        checkedFields,
        templateCode,
        groupAfterUserFilterValue,
        extendedAttributesEntries,
        fetchTableAttributesData,
        handleFinish,
        setUsingGroup,
        setCheckedFields,
        setGroupAfterUserFilterValue,
        handleCheck,
    } = useDDGroupingSettingsModalOpener({drilldownReferenceRules, index});

    return (
        <div>
            <ModalOpenerComponent
                onShow={fetchTableAttributesData}
                shouldConfirm={() => form.isFieldsTouched()}
                ref={modalOpenerRef}
                handleCancel={setIsModalOpen => {
                    setIsModalOpen(false);
                    setFieldsValueUntouched(form, initialValues);
                }}
                handleSave={() => {
                    form.submit();
                }}
                component={(
                    <Popover
                        placement="bottomRight"
                        content={() => 'Настройки группировки'}
                    >
                        <DynamicIcon
                            type="Settings"
                            className="dd-grouping-settings-modal-opener__settings-icon"
                            style={{cursor: 'pointer', textAlign: 'center'}}
                        />
                    </Popover>
                )}
                modalProps={{
                    title: 'Настройки итоговой строки',
                    width: '85%',
                    style: {maxWidth: '1700px'},
                    forceRender: false,
                    destroyOnClose: true,
                    centered: true,
                }}
                loadingControls={{save: isSavingData}}
            >
                <DDGroupingSettingsModalForm
                    form={form}
                    attributesEntries={attributesEntries}
                    extendedAttributesEntries={extendedAttributesEntries}
                    templateCode={templateCode}
                    checkedFields={checkedFields}
                    usingGroup={usingGroup}
                    groupAfterUserFilterValue={groupAfterUserFilterValue}
                    isAttributesLoaded={isAttributesLoaded}
                    setCheckedFields={setCheckedFields}
                    setUsingGroup={setUsingGroup}
                    setGroupAfterUserFilterValue={setGroupAfterUserFilterValue}
                    handleCheck={handleCheck}
                    handleFinish={handleFinish}
                />
            </ModalOpenerComponent>
        </div>
    );
};
